import { PhoneIcon, MailIcon } from '@heroicons/react/solid'
import clsx from 'clsx'
import * as React from 'react'
import Obfuscate from 'react-obfuscate'

export interface ContactInfoProps {
  address?: string
  email?: string
  phone?: string
}

function ContactInfo({ address, email, phone }: ContactInfoProps) {
  return (
    <div>
      {phone && (
        <div className="flex">
          <div className="shrink-0">
            <PhoneIcon className="w-6 h-6 text-secondary" aria-hidden="true" />
          </div>
          <div className="ml-3 text-base text-secondary">
            <p>
              <Obfuscate tel={phone} />
            </p>
          </div>
        </div>
      )}
      {email && (
        <div
          className={clsx('flex', {
            'mt-6': phone,
          })}
        >
          <div className="shrink-0">
            <MailIcon className="w-6 h-6 text-secondary" aria-hidden="true" />
          </div>
          <div className="ml-3 text-base text-secondary">
            <p>
              <Obfuscate email={email} />
            </p>
          </div>
        </div>
      )}
      {address && (
        <div
          className={clsx('text-base text-secondary', {
            'mt-2': phone || email,
          })}
        >
          <p>{address}</p>
        </div>
      )}
    </div>
  )
}

export { ContactInfo }
